<template>
  <similar-jobs-preview
    collection-name="jobSearchCollection"
    text="No such similar jobs are available at the moment"
    class="is-full-width"
  ></similar-jobs-preview>
</template>
<script>
import { getResouceUrl } from '@/helpers/utils/searchUtils'
import SimilarJobsPreview from '@/components/Job/SimilarJobsPreview'
export default {
  components: {
    SimilarJobsPreview
  },
  computed: {
    jobDetail() {
      return this.get(this.$store.state.collection.collectionResponses, [
        'jobDetails'
      ])
    },
    categoriesValue() {
      return this.jobDetail.categories.map(each => each.slug)
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const filterFields = {
        categories: this.categoriesValue
      }
      const paginationFields = {
        limit: 4
      }
      const contentUrl = '/api/v1/job/search/'
      const resourceUrl = getResouceUrl(contentUrl, {
        ...filterFields,
        ...paginationFields
      })
      const { data } = await this.$axios.get(resourceUrl)
      const similarJobsData = data.results
        .filter(x => x.slug !== this.$route.params.jobSlug)
        .slice(0, 3)
      this.$store.commit('collection/setCollectionData', [
        'jobSearchCollection',
        { results: similarJobsData }
      ])
    },
    goToSearchPage() {
      this.$router.push(
        this.localePath({
          name: 'job-search'
        })
      )
    }
  }
}
</script>
